/* eslint-disable camelcase */
import { actions } from '../../utils/constants';

export const asyncFetchPerformedTests = ({
    status,
    search,
    page,
    limit,
    center_id,
}) => ({
    type: actions.ASYNC_FETCH_PERFORMED_TESTS,
    payload: { status, search, page, limit, center_id },
});

export const asyncExportTestConducted = ({
    status,
    center_id,
}) => ({
    type: actions.ASYNC_EXPORT_PERFORMED_TESTS,
    payload: { status, center_id },
});

export const resetContentExportTestConducted = () => ({
    type: actions.RESET_CONTENT_CSV_TO_EXPORT_PERFORMED_TESTS,
});

export const asyncApprovesTests = (value, currentFilters)=>({
    type: actions.ASYNC_APPROVES_TEST,
    payload: { testId: value, currentFilters },
});

export const asyncCorrectionTests = (value, currentFilters)=>({
    type: actions.ASYNC_CORRECTION_TEST,
    payload: { testId: value, currentFilters },
});

export const asyncDiscardTest = (value, currentFilters)=>({
    type: actions.ASYNC_DISCARD_TEST,
    payload: { testId: value, currentFilters },
});



// WEBPACK FOOTER //
// ./src/components/tests-conducted/tests-conducted.actions.js